module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"charts:title":"Графики","charts:ds-select":"Данные","charts:style-settings":"Внешний вид"},"en":{"charts:title":"Charts","charts:ds-select":"Data","charts:style-settings":"Stylization"}}')
  delete Component.options._Ctor
}
